<template>
  <div class="space-y-6">
    <div class="space-y-4">
      <UiKitInput
        v-model="form.smtp_host"
        label="SMTP Host"
        placeholder="smtp.gmail.com"
      />

      <UiKitInput
        v-model="form.smtp_port"
        label="SMTP Port"
        type="number"
        placeholder="587"
      />

      <UiKitInput
        v-model="form.smtp_email"
        label="SMTP Email"
        type="email"
        placeholder="example@mail.com"
      />
    </div>

    <div class="flex gap-3 pt-4 border-t border-hui-divider">
      <UiKitButton type="button" color="primary" :loading="loading" :disabled="loading" @click="saveSettings">
        Сохранить настройки
      </UiKitButton>
      <UiKitButton type="button" color="default" variant="flat" @click="closeModal">
        Отмена
      </UiKitButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import consola from 'consola'
import { useKitToast } from '@shared/ui/kit'
import { APIAdminInstitution } from '~/fsd-pages/admin/api'
import { useModalStore } from '@shared/model'
import type { EmailSettings } from '@entities/institution'

const emit = defineEmits<{
  'update:size': [size: string]
}>()

const { toast: kitToast } = useKitToast()
const toast = {
  add: (o: { title?: string; description?: string; color?: string; timeout?: number }) =>
    kitToast({ color: o.color === 'green' ? 'success' : o.color === 'red' ? 'danger' : o.color === 'orange' ? 'warning' : 'default', title: o.title, description: o.description, timeout: o.timeout }),
}

const modalStore = useModalStore()
const loading = ref(false)

const form = ref<EmailSettings>({
  smtp_host: '',
  smtp_port: '',
  smtp_email: '',
})

const loadSettings = async () => {
  try {
    loading.value = true
    const response = await APIAdminInstitution.getEmailSettings()
    const settings = response.email || response
    form.value = { ...settings }
  } catch (error) {
    consola.error('Ошибка загрузки настроек Email:', error)
    toast.add({ title: 'Ошибка', description: 'Ошибка загрузки настроек', color: 'red' })
  } finally {
    loading.value = false
  }
}

const saveSettings = async () => {
  try {
    loading.value = true
    await APIAdminInstitution.updateEmailSettings(form.value)
    toast.add({ title: 'Сохранено', description: 'Настройки Email успешно сохранены', color: 'green' })
    setTimeout(() => {
      closeModal()
    }, 1500)
  } catch (error) {
    consola.error('Ошибка сохранения настроек Email:', error)
    toast.add({ title: 'Ошибка', description: 'Ошибка сохранения настроек', color: 'red' })
  } finally {
    loading.value = false
  }
}

const closeModal = () => {
  modalStore.close()
}

onMounted(() => {
  emit('update:size', 'l')
  loadSettings()
})
</script>
